import { render, staticRenderFns } from "./Port.vue?vue&type=template&id=0dfe52bc&scoped=true&"
import script from "./Port.vue?vue&type=script&lang=js&"
export * from "./Port.vue?vue&type=script&lang=js&"
import style0 from "./Port.vue?vue&type=style&index=0&id=0dfe52bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe52bc",
  null
  
)

export default component.exports